<template>
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 14.5H1.5C0.948 14.5 0.5 14.052 0.5 13.5V2.5C0.5 1.948 0.948 1.5 1.5 1.5H14.5C15.052 1.5 15.5 1.948 15.5 2.5V13.5C15.5 14.052 15.052 14.5 14.5 14.5Z"
      stroke="#111111"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path d="M2.5 4.5L8 9L13.5 4.5" stroke="#111111" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
  </svg>
</template>
